import ChatAI from "./chatAI";

export default ChatAI;